import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase.config';

// Currency symbols mapping
export const CURRENCY_SYMBOLS = {
  'USD': '$',
  'EUR': '€',
  'GBP': '£',
  'JPY': '¥',
  'INR': '₹',
  'CAD': 'C$',
  'AUD': 'A$',
  'CHF': 'CHF',
  'CNY': '¥',
  'AED': 'د.إ',
  'SAR': '﷼',
  'PKR': '₨',
  'BDT': '৳',
  'NPR': '₨',
  'LKR': '₨',
  'MYR': 'RM',
  'SGD': 'S$',
  'THB': '฿',
  'IDR': 'Rp',
  'PHP': '₱',
  'VND': '₫',
  'KRW': '₩',
  'HKD': 'HK$',
  'TWD': 'NT$',
  'BRL': 'R$',
  'MXN': '$',
  'ARS': '$',
  'CLP': '$',
  'COP': '$',
  'PEN': 'S/',
  'ZAR': 'R',
  'EGP': '£',
  'NGN': '₦',
  'KES': 'KSh',
  'GHS': '₵',
  'MAD': 'د.م.',
  'TND': 'د.ت',
  'DZD': 'د.ج',
  'ETB': 'Br',
  'UGX': 'USh',
  'TZS': 'TSh',
  'RWF': 'RF',
  'BIF': 'FBu',
  'DJF': 'Fdj',
  'SOS': 'S',
  'ERN': 'Nfk',
  'SDG': 'ج.س.',
  'SSP': '£',
  'CDF': 'FC',
  'AOA': 'Kz',
  'ZMW': 'ZK',
  'BWP': 'P',
  'SZL': 'L',
  'LSL': 'L',
  'NAD': 'N$',
  'MZN': 'MT',
  'MWK': 'MK',
  'ZWL': 'Z$'
};

// Get company currency from Firestore
export const getCompanyCurrency = async (companyId) => {
  try {
    if (!companyId) return 'INR'; // Default fallback
    
    const settingsRef = doc(db, `companies/${companyId}/settings/default`);
    const settingsSnap = await getDoc(settingsRef);
    
    if (settingsSnap.exists()) {
      const data = settingsSnap.data();
      return data.currency || 'INR';
    }
    
    return 'INR'; // Default fallback
  } catch (error) {
    console.error('Error getting company currency:', error);
    return 'INR'; // Default fallback
  }
};

// Format currency with dynamic symbol
export const formatCurrency = (amount, currencyCode = 'INR') => {
  const symbol = CURRENCY_SYMBOLS[currencyCode] || '₹';
  
  // Format number with proper locale
  const formattedNumber = new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount || 0);
  
  return `${symbol}${formattedNumber}`;
};

// Format currency for PDF (avoid symbol issues)
export const formatCurrencyPdf = (amount, currencyCode = 'INR') => {
  const n = Number(amount || 0);
  const symbol = CURRENCY_SYMBOLS[currencyCode] || '₹';
  
  return `${symbol} ${n.toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
};

// Get currency symbol only
export const getCurrencySymbol = (currencyCode = 'INR') => {
  return CURRENCY_SYMBOLS[currencyCode] || '₹';
};

// Format currency with Intl API (for reports)
export const formatCurrencyIntl = (amount, currencyCode = 'INR') => {
  try {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount || 0);
  } catch (error) {
    // Fallback if currency code is not supported
    return formatCurrency(amount, currencyCode);
  }
};
